<template>
  <div class="animated fadeIn">
    <div v-if="loading">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-row" v-else>
      <div class="w-full">
        <div class="customer-tab">
          <div
            slot="no-body"
            class="tabs-container pt-6"
            id="view-customer-tab"
          >
            <vx-card>
              <div class="mr-2 mb-1 order-1" style="">
                <vs-table
                  class="ticketsearch"
                  :max-items="descriptionItems[0]"
                  pagination
                  :data="ticketListData"
                  description
                  search
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <vs-th>{{ $t("Customer Name") }}</vs-th>
                  <template slot="header">
                    <div class="list-heading">
                      {{ $t("tickets.label.customer.entity") }}
                    </div>
                    <div class="mr-4 order-1">
                      <v-select
                        label="mCodeValue"
                        v-model="customerdateFilter"
                        :options="['Week', 'Month', 'Custom']"
                        placeholder="Select One"
                        @input="datefilters"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-100 w-full"
                      >
                      </v-select>
                    </div>
                  </template>
                  <template slot="header">
                    <div class="order-1">
                      <v-select
                        label="mCodeValue"
                        v-model="Customer.statusType"
                        :options="ticketTemplateInfo.statusData"
                        @input="getCustomerSearch"
                        placeholder="Select One"
                        :reduce="(obj) => obj.mCodeValue"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-100 w-full"
                      />
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th>{{
                      $t("tickets.label.customer.businessEntity")
                    }}</vs-th>
                    <vs-th>{{ $t("tickets.label.customer.ticket") }}</vs-th>
                    <vs-th>{{ $t("tickets.label.customer.ticketDate") }}</vs-th>
                    <vs-th>{{ $t("tickets.label.customer.ticketAge") }}</vs-th>
                    <vs-th>{{ $t("tickets.label.customer.priority") }}</vs-th>
                    <vs-th>{{ $t("tickets.label.customer.category") }}</vs-th>
                    <vs-th>{{ $t("tickets.label.customer.createdBy") }}</vs-th>
                    <vs-th>{{ $t("tickets.label.customer.assignedto") }}</vs-th>
                    <vs-th>{{ $t("tickets.label.customer.closedBy") }}</vs-th>
                    <vs-th v-if="!isClosedStatus()">{{
                      $t("tickets.label.customer.escalated")
                    }}</vs-th>
                    <vs-th>{{
                      $t("tickets.label.customer.resolutionDate")
                    }}</vs-th>
                    <vs-th>{{ $t("tickets.label.customer.status") }}</vs-th>
                    <vs-th class="tHeadCenter">{{
                      $t("tickets.label.customer.action")
                    }}</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="Custome"
                      v-for="(Custome, index) in data"
                    >
                      <vs-td :data="Custome.clientName">{{
                        Custome.clientName
                      }}</vs-td>
                      <vs-td :data="Custome.id">{{ Custome.id }}</vs-td>
                      <vs-td :data="Custome.ticketDate">{{
                        getDate(Custome.ticketDate)
                      }}</vs-td>
                      <vs-td :data="Custome.timeElapsed">{{
                        Custome.timeElapsed
                      }}</vs-td>
                      <vs-td :data="Custome.priority">
                        <vs-chip
                          :color="priorityColor(Custome.priority)"
                          class="priority-status"
                          >{{ Custome.priority }}
                        </vs-chip>
                      </vs-td>
                      <vs-td :data="Custome.problemDescription">{{
                        Custome.problemDescription
                      }}</vs-td>
                      <vs-td :data="Custome.createUser">{{
                        Custome.createUser
                      }}</vs-td>
                      <vs-td :data="Custome.createUser">{{
                        Custome.createUser
                      }}</vs-td>
                      <vs-td :data="Custome.closedByuser">{{
                        Custome.closedByuser
                      }}</vs-td>
                      <vs-td
                        :data="Custome.isEscalted"
                        v-if="
                          Custome.status != 'Closed Resolved' &&
                          Custome.status != 'Closed Duplicate' &&
                          Custome.status != 'CLOSED'
                        "
                      >
                        {{ Custome.isEscalted === true ? "yes" : "No" }}
                      </vs-td>
                      <vs-td class="container_img">{{
                        Customer.closedDate ? getDate(Customer.closedDate) : "-"
                      }}</vs-td>
                      <vs-td :data="Custome.status">
                        <vs-chip
                          :color="statusColor(Custome.status)"
                          class="priority-status"
                        >
                          {{ Custome.status }}
                        </vs-chip></vs-td
                      >
                      <vs-td class="whitespace-no-wrap">
                        <div class="container_img">
                          <feather-icon
                            v-if="
                              Custome.isEscalted === false &&
                              Custome.status != 'Closed Resolved' &&
                              Custome.status != 'Closed Duplicate' &&
                              Custome.status != 'CLOSED'
                            "
                            title="Escalated"
                            icon="AlertTriangleIcon"
                            @click="getEscalatedOfficeTickets(Custome.id)"
                            class="icon_row"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current text-danger"
                          />
                          <!-- <feather-icon
                            title="Edit Ticket"
                            icon="EditIcon"
                            @click.stop="openEntityEditModal(Custome)"
                            class="icon_row"
                            svgClasses="w-5 h-5 stroke-current orange_icon"
                          /> -->
                          <feather-icon
                            v-if="Custome.status == 'OPEN'"
                            title="Close Ticket"
                            @click.stop="
                              clientId = Custome.id;
                              removeTicket(Custome.id);
                            "
                            icon="XIcon"
                            class="icon_row"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <div class="centerx">
                  <vs-popup
                    classContent="popup-example"
                    :title="$t('tickets.label.edit.header')"
                    :active.sync="ticketEntityPopup"
                    class="popup-close"
                    ><ValidationObserver ref="observer1">
                      <form ref="form">
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <vs-input
                              :label="$t('tickets.label.edit.Ticket Number')"
                              class="w-full font-semibold starlabel"
                              readonly
                              v-model="ticket.ticketNumber"
                            />
                          </div>

                          <div class="vx-col md:w-1/2 w-full">
                            <div class="dropdown-with-label">
                              <small class="date-label"
                                >{{ $t("tickets.label.edit.Status")
                                }}<span class="required"> *</span></small
                              >
                              <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Status"
                                :key="resetKey"
                              >
                                <v-select
                                  label="mCodeValue"
                                  :options="ticketData.statusType"
                                  placeholder="Select Category"
                                  :reduce="
                                    (mCodeValue) => mCodeValue.mCodeValue
                                  "
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="ticket.status"
                                  class="min-w-200 w-full mb-2"
                                >
                                  <template v-slot:option="option">{{
                                    option.mCodeValue
                                  }}</template>
                                </v-select>
                                <span
                                  class="validate-error"
                                  style="color: red"
                                  >{{ errors[0] }}</span
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="dropdown-with-label">
                              <small class="date-label"
                                >{{ $t("tickets.label.edit.Category")
                                }}<span class="required"> *</span></small
                              >
                              <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Category"
                                :key="resetKey"
                              >
                                <v-select
                                  label="mCodeValue"
                                  :options="ticketTemplates.problemsDatas"
                                  placeholder="Select Category"
                                  :reduce="(mCodeValue) => mCodeValue.id"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="ticket.problemCode"
                                  @input="getEntitySubCategory()"
                                  class="min-w-200 w-full mb-2"
                                >
                                  <template v-slot:option="option">{{
                                    option.mCodeValue
                                  }}</template>
                                </v-select>
                                <span
                                  class="validate-error"
                                  style="color: red"
                                  >{{ errors[0] }}</span
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="dropdown-with-label">
                              <small class="date-label"
                                >{{ $t("tickets.label.edit.Sub Category")
                                }}<span class="required"> *</span></small
                              >
                              <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Sub category"
                                :key="resetKey"
                              >
                                <v-select
                                  label="subCategory"
                                  :options="subCategoryItem"
                                  placeholder="Select Sub Category"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="ticket.subCategory"
                                  :reduce="
                                    (subCategory) => subCategory.subCategory
                                  "
                                  class="min-w-200 w-full mb-2"
                                />
                                <span
                                  class="validate-error"
                                  style="color: red"
                                  >{{ errors[0] }}</span
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="dropdown-with-label">
                              <small class="date-label"
                                >{{ $t("tickets.label.edit.Assign To")
                                }}<span class="required"> *</span></small
                              >
                              <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Assign to"
                                :key="resetKey"
                              >
                                <v-select
                                  label="userName"
                                  :options="ticketTemplates.usersData"
                                  placeholder="--Select One--"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="ticket.assignedTo"
                                  :reduce="(userName) => userName.id"
                                  class="min-w-200 w-full mb-2"
                                />
                                <span
                                  class="validate-error"
                                  style="color: red"
                                  >{{ errors[0] }}</span
                                >
                              </ValidationProvider>
                            </div>
                          </div>

                          <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                            <ValidationProvider
                              rules="required"
                              v-slot="{ errors }"
                              name="Title"
                              :key="resetKey"
                            >
                              <vs-input
                                :label="$t('tickets.label.edit.Title')"
                                v-model="ticket.title"
                                class="w-full font-semibold mb-2 starlabel"
                                icon-no-border
                                :danger="false"
                                danger-text="wrong input"
                              />
                              <span class="validate-error" style="color: red">{{
                                errors[0]
                              }}</span>
                            </ValidationProvider>
                          </div>
                          <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                            <div class="dropdown-with-label">
                              <small class="date-label"
                                >{{ $t("tickets.label.edit.Comment")
                                }}<span class="required"> *</span></small
                              >
                              <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Comment"
                                :key="resetKey"
                              >
                                <vs-textarea
                                  class="w-full"
                                  v-model="ticket.description"
                                  hint="Please provide as much detail as possible so we can best assist you."
                                />
                                <span
                                  class="validate-error"
                                  style="color: red"
                                  >{{ errors[0] }}</span
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                          <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                            <pick-file @fileUpdate="changeFile" />
                          </div>
                        </div>

                        <div style="height: 30px"></div>
                        <div class="center">
                          <span class="ml-1 mr-1">
                            <vs-button
                              @click="updateEntityTicket"
                              class="footerButton-next"
                              style="top: 0px"
                              >{{ $t("setup.label.Submit") }}</vs-button
                            >
                          </span>
                        </div>
                        <div style="height: 20px"></div>
                      </form>
                    </ValidationObserver>
                    <validation-popup
                      :errorMessage="errorMessage"
                      :warningPopup="warningPopup"
                      :warningText="warningText"
                      @closeWarning="warningPopup = false"
                    ></validation-popup>
                  </vs-popup>
                </div>
                <div class="centerx">
                  <vs-popup
                    classContent="popup-example"
                    :title="$t('tickets.label.Close Ticket')"
                    :active.sync="cancelTicketPopup"
                    class="popup-close mid-popup"
                  >
                    <form ref="form">
                      <div class="vx-col w-full">
                        <div class="dropdown-with-label">
                          <small class="date-label"
                            >{{ $t("tickets.label.edit.Status")
                            }}<span class="required"> *</span></small
                          >
                          <v-select
                            label="mCodeValue"
                            :options="cancelStatus"
                            placeholder="--Select One--"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="cancelObj.status"
                            :reduce="(userName) => userName.id"
                            class="min-w-200 w-full mb-2"
                          />
                        </div>
                      </div>
                      <div class="vx-col sm:w-full">
                        <div class="dropdown-with-label">
                          <small class="date-label"
                            >{{ $t("tickets.label.Resolution Description")
                            }}<span class="required"> *</span></small
                          >
                          <vs-textarea
                            class="w-full textbox"
                            v-model="cancelObj.resolutionDescription"
                            hint="Please provide as much detail as possible so we can best assist you."
                          />
                        </div>
                      </div>
                      <div class="center">
                        <span class="ml-1 mr-1">
                          <vs-button
                            @click="cancelTicket"
                            class="footerButton-next mt-4 mb-4"
                            style="top: 0px"
                            >{{ $t("setup.label.Submit") }}</vs-button
                          >
                        </span>
                      </div>
                    </form>
                  </vs-popup>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        button-close-hidden
        :active.sync="active"
        title="Date Filter"
        class="no-header mid-popup popup-close"
      >
        <div class="vx-col mb-2 w-full"></div>
        <div class="vx-row mb-8">
          <div class="vx-col md:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("Start Date") }}<span class="required"> *</span></small
              >
              <datepicker
                name="start-date"
                :placeholder="$t('Start Date')"
                v-model="endDate"
                :disabled="dateDisabled"
              ></datepicker>
            </div>
          </div>
          <div class="vx-col md:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("End Date") }}<span class="required"> *</span></small
              >
              <datepicker
                name="end-date"
                :placeholder="$t('End Date')"
                v-model="startDate"
                :disabled="dateDisabled"
              ></datepicker>
            </div>
          </div>
        </div>
        <div class="center">
          <span class="ml-1 mr-8">
            <vs-button type="border" @click="cancelCustomDate">{{
              $t("Cancel")
            }}</vs-button>
          </span>
          <span class="mr-8">
            <vs-button @click="customsDate">{{ $t("Set") }}</vs-button>
          </span>
        </div>
        <div class="p-6"></div>
      </vs-popup>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import moment from "moment";
import { setHeader, removeHeader } from "@/http";
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import PickFile from "@/components/PickFile.vue";
const ticketObj = {
  dueTime: null,
  assignedTo: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  teamCode: "",
  status: "",
  title: "",
  type: "Customer",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MMMM YYYY"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: null,
  ticketNumber: null,
};
export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      tabnumber: 0,
      resetKey: 0,
      descriptionItems: [10, 20, 30],
      startDate: moment().subtract(0, "d").format("YYYY-MM-DD"),
      endDate: moment().subtract(7, "d").format("YYYY-MM-DD"),
      delId: 0,
      ticketId: "",
      disabled: false,
      // ticketPopup: false,
      cancelTicketPopup: false,
      ticketEntityPopup: false,
      customerdateFilter: "Week",
      active: false,
      entityId: null,
      officeId: null,
      cancelStatus: [],
      Customer: {
        statusType: "OPEN",
      },
      clientId: null,
      ticket: { ...ticketObj },
      bulkUploads: {
        file: null,
      },
      dateDisabled: true,
      warningPopup: false,
      errorMessage: "",
      warningText: "",
      cancelObj: {
        status: "",
        resolutionDescription: "",
        ticketURL: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
      },
    };
  },

  computed: {
    ...mapState({
      subCategoryItem: (state) => state.ticket.ticketSubCategory,
      ticketTemplateInfo: (state) => state.ticket.ticketTemplateInfo,
      ticketListData: (state) => state.ticket.ticketListData,
      teamUsers: (state) => state.customer.teamUsers,
      ticketById: (state) => state.customerTicket.ticketById,
      ticketViewById: (state) => state.customer.ticketViewById,
      ticketCreated: (state) => state.entity.createTicketResponse,
      ticketData: (state) => state.entity.editTicketTemplate,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    ticketTemplates() {
      return this.$store.getters["customer/getTicketTemplate"];
    },
    activeTab: {
      get() {
        return this.tabnumber;
      },
      set(val) {
        this.tabnumber = val;
        this.Customer.statusType = "OPEN";
        this.getCustomerSearch(val);
      },
    },
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    AtomSpinner,
    ValidationProvider,
    ValidationObserver,
    PickFile,
  },
  methods: {
    editTicket(Customer) {
      this.ticketId = Customer.id;
      this.clientId = Customer.clientId;
      this.resetKey++;
      this.$router.push({
        name: "Edit Ticket",
        params: { id: Customer.clientId, ticketId: Customer.id },
        query: { ticketing: true, type: "entity" },
      });
    },
    priorityColor(priority) {
      let color = "";
      switch (priority.toUpperCase()) {
        case "CRITICAL":
          color = "red";
          break;
        case "HIGH":
          color = "orange";
          break;
        case "MEDIUM":
          color = "#FFC107";
          break;
        case "LOW":
          color = "blue";
          break;
        default:
          color = "black";
      }
      return color;
    },
    statusColor(status) {
      let color = "";
      switch (status.toUpperCase()) {
        case "OPEN":
          color = "primary";
          break;
        case "CLOSE":
          color = "danger";
          break;
        case "WORKING":
          color = "warning";
          break;
        default:
          color = "black";
      }
      return color;
    },
    isClosedStatus() {
      if (
        this.Customer.statusType !== "CLOSED" &&
        this.Customer.statusType !== "Closed Duplicate" &&
        this.Customer.statusType !== "Closed Resolved"
      ) {
        return false;
      } else {
        return true;
      }
    },
    async cancelTicket() {
      try {
        if (this.ticket.type === "Customer") {
          this.cancelObj.ticketURL = `${this.ticket.ticketURL2}${this.clientId}`;
          await this.$store.dispatch("customer/cancelTicketAction", {
            id: this.ticketId,
            data: this.cancelObj,
          });
        } else {
          this.cancelObj.ticketURL = `${this.ticket.ticketURL2}${this.clientId}`;
          await this.$store.dispatch("entity/cancelTicketAction", {
            id: this.ticketId,
            data: this.cancelObj,
          });
        }
        this.cancelTicketPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket Updated Successfully!",
          type: "success",
        });
        this.getCustomerSearch();
      } catch (e) {
        console.log("something went to wrong closeing Ticket:", e);
      }
    },
    async getSubCategory(categoryId) {
      try {
        await this.$store.dispatch("ticket/getTicketSubCategory", categoryId);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getEntitySubCategory() {
      try {
        this.$store.dispatch(
          "entity/setTicketSubcategory",
          this.ticket.problemCode
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getUserByTeam() {
      try {
        this.$store.dispatch("customer/getUserByTeam", this.ticket.teamCode);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    // openEditModal(Customer) {
    //   this.ticketId = Customer.id;
    //   this.clientId = Customer.clientId;
    //   this.resetKey++;
    //   this.ticketPopup = true;
    // },
    openEntityEditModal(Custome) {
      this.ticketId = Custome.id;
      this.clientId = Custome.clientId;
      this.resetKey++;
      this.ticketEntityPopup = true;
    },
    // async updateTicket() {
    //   const isValid = await this.$refs.observer.validate();
    //   if (!isValid) return;
    //   let payload = {
    //     assignedTo: this.ticket.assignedTo,
    //     dateFormat: "dd MMMM yyyy",
    //     locale: "en",
    //     priority: this.ticket.priority,
    //     problemCode: this.ticket.problemCode,
    //     status: this.ticket.status,
    //     subCategory: this.ticket.subCategory,
    //     subCategoryes: this.ticket.subCategory,
    //     teamId: this.ticket.teamCode,
    //     teamUserId: this.ticket.assignedTo,
    //     ticketDate: this.ticket.ticketDate,
    //     ticketId: this.ticketId,
    //     ticketURL: `${this.ticket.ticketURL2}${this.clientId}`,
    //     comments: this.ticket.description,
    //   };
    //   try {
    //     await this.$store.dispatch("customer/updateTicket", {
    //       id: this.ticketId,
    //       data: payload,
    //     });
    //     // this.ticketPopup = false;
    //     this.getTickets();
    //     this.$swal({
    //       title: "Success",
    //       icon: "success",
    //       text: "Ticket Updated Successfully!",
    //       type: "success",
    //     });
    //   } catch (e) {
    //     // this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
    //     //   "The parameter",
    //     //   ""
    //     // );
    //     // this.warningPopup = true;
    //     // this.errors = e.message.errors;
    //   }
    // },
    async getByIdticket() {
      try {
        this.ticket = await this.$store.dispatch("entity/getTicketInfo", {
          entityId: this.entityId,
          id: this.officeId,
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getTickets() {
      try {
        this.$store.dispatch("customer/setClientTickets", this.clientId);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async removeTicket(id) {
      this.cancelTicketPopup = true;
      this.ticketId = id;
      this.cancelObj = {
        status: "",
        resolutionDescription: "",
        ticketURL: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
      };
      try {
        this.cancelStatus = await this.$store.dispatch(
          "entity/getCancelTicketTemplate"
        );
        this.getTickets();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    datefilters() {
      if (this.customerdateFilter == "Week") {
        this.startDate = moment().subtract(0, "d").format("YYYY-MM-DD");
        this.endDate = moment().subtract(7, "d").format("YYYY-MM-DD");
        this.dateDisabled = true;
      } else if (this.customerdateFilter == "Month") {
        this.startDate = moment().subtract(0, "d").format("YYYY-MM-DD");
        this.endDate = moment().subtract(30, "d").format("YYYY-MM-DD");
        this.dateDisabled = true;
      } else if (this.customerdateFilter == "Custom") {
        this.dateDisabled = false;
        this.active = true;
      }
      this.getCustomerSearch();
    },
    cancelCustomDate() {
      this.active = false;
      this.customerdateFilter = "";
    },
    customsDate() {
      this.startDate = moment(this.startDate).format("YYYY-MM-DD");
      this.endDate = moment(this.endDate).format("YYYY-MM-DD");
      this.getCustomerSearch();
      this.active = false;
      this.customerdateFilter = "";
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },

    async getTicketTemplate() {
      try {
        this.$store.dispatch("customer/setTicketTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCustomerSearch() {
      try {
        this.disabled = true;
        await this.$store.dispatch("ticket/fetchCustomerSearch", {
          type: "Office",
          statusType: this.Customer.statusType,
          fromDate: this.endDate,
          toDate: this.startDate,
        });
        this.disabled = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    // async ticketTemplate() {
    //   try {
    //     await this.$store.dispatch("customer/setTicketTemplate");
    //     this.getTicketById();
    //   } catch (error) {
    //     throw Error(
    //       error.message.errors[0].defaultUserMessage ||
    //         `Api failed with status code: ${error.message.httpStatusCode}`
    //     );
    //   }
    // },
    // async getTicketById() {
    //   try {
    //     await this.$store.dispatch("customerTicket/setTicketById", {
    //       clientId: this.clientId,
    //       id: this.ticketId,
    //     });
    //     await this.getSubCategory(this.ticketById.problemCode);
    //     await this.$store.dispatch(
    //       "customer/getUserByTeam",
    //       this.ticketById.teamId
    //     );
    //     this.ticket.assignedTo = this.ticketById.teamUserId;
    //     this.ticket.priority = this.ticketById.priority;
    //     this.ticket.problemCode = this.ticketById.problemCode;
    //     this.ticket.subCategory = this.ticketById.subCategoryes;
    //     this.ticket.status = this.ticketById.status;
    //     this.ticket.description = this.ticketById.lastComment;
    //     this.ticket.sourceOfTicket = this.ticketById.sourceOfTicket;
    //     this.ticket.teamCode = this.ticketById.teamId;
    //   } catch (error) {
    //     throw Error(
    //       error.message.errors[0].defaultUserMessage ||
    //         `Api failed with status code: ${error.message.httpStatusCode}`
    //     );
    //   }
    // },
    async updateEntityTicket() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;
      try {
        let payload = {
          assignedTo: this.ticket.assignedTo,
          comments: this.ticket.description,
          ticketNumber: this.ticket.ticketNumber,
          status: this.ticket.status,
          title: this.ticket.title,
          priority: this.ticket.priority,
          problemCode: this.ticket.problemCode,
          subCategory: this.ticket.subCategory,
          locale: "en",
          ticketURL: `${this.ticket.ticketURL2}${this.entityId}`,
        };
        let formData = new FormData();
        setHeader("Content-Type", "multipart/form-data");
        formData.append("name", this.ticket.title);
        formData.append("description", this.ticket.description);
        formData.append("file", this.bulkUploads.file);
        removeHeader("Content-Type");
        await this.$store.dispatch("entity/updateTicketAction", {
          id: this.ticketId,
          data: payload,
        });
        this.getTickets();
        formData.append("childEntityId", this.ticketCreated);
        this.$store.dispatch("entity/createTicketDocAction", {
          id: this.clientId,
          data: formData,
        });
        this.ticketEntityPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket Updated Successfully!",
          type: "success",
        });
        this.ticket = { ...ticketObj };
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async ticketEntityTemplate() {
      try {
        this.$store.dispatch("entity/setTicketTemplate");
        await this.$store.dispatch("entity/getEditTicketData", {
          entityId: this.clientId,
          ticketId: this.ticketId,
        });
        this.ticket.ticketNumber = this.ticketData.ticketNumber;
        this.ticket.status = this.ticketData.status;
        this.ticket.priority = this.ticketData.priority;
        this.ticket.problemCode = this.ticketData.problemCode;
        this.getEntitySubCategory();
        this.ticket.title = this.ticketData.title;
        this.ticket.description = this.ticketData.lastComment;
        this.ticket.subCategory = this.ticketData.subCategoryStatus;
        for (let temp of this.ticketData.usersData) {
          if (temp.userName === this.ticketData.userName)
            this.ticket.assignedTo = temp.id;
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    changeFile(file) {
      this.bulkUploads.file = file;
    },
    getEscalatedCustomerTickets(id) {
      this.$swal({
        title: "Do you want to escalate this ticket?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.$store
              .dispatch("ticket/getEscalatedCustomerTickets", id)
              .then(() => {
                this.$swal({
                  title: "Success",
                  text: "Your ticket has been escalated successfully..",
                  icon: "success",
                });
                this.getCustomerSearch();
              });
          } catch (error) {
            this.$toasted.error("something went wrong!!");
          }
        }
      });
    },
    getEscalatedOfficeTickets(id) {
      this.$swal({
        title: "Do you want to escalate this ticket?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.$store
              .dispatch("ticket/getEscalatedOfficeTickets", id)
              .then(() => {
                this.$swal({
                  title: "Success",
                  text: "Your ticket has been escalated successfully..",
                  icon: "success",
                });
                this.getCustomerSearch();
              });
          } catch (error) {
            this.$toasted.error("something went wrong!!");
          }
        }
      });
    },
  },
  watch: {
    "ticket.problemCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getSubCategory(this.ticket.problemCode);
      }
    },
    "ticket.teamCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getTeamUsers(this.ticket.teamCode);
      }
    },
    // ticketPopup(newval) {
    //   if (newval) {
    //     this.ticketTemplate();
    //   }
    // },
    tabnumber(newVal) {
      !newVal ? (this.ticket.type = "Customer") : (this.ticket.type = "Office");
    },
    ticketEntityPopup(newval) {
      if (newval) {
        this.ticketEntityTemplate();
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.getCustomerSearch();
    await this.$store.dispatch("ticket/fetchTicketTemplate");
    this.loading = false;
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 50%;
}
.priority-status.vs-chip-primary {
  background: #b5dafb !important;
  border: 1px solid #3c6bec;
  color: #3c6bec !important;
}
.priority-status.vs-chip-warning {
  background: #fdf6db !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.priority-status.vs-chip-danger {
  background: #ffc2c2 !important;
  border: 1px solid #ff3838;
  color: #ff3838 !important;
}
.priority-status.vs-chip-orange {
  background: #fbd9b5 !important;
  border: 1px solid #ff8914;
  color: #ff8914 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}
.no-header .vs-popup .vs-popup--header {
  background: rgba(1, 1, 1, 0) !important;
}
.vdp-datepicker__calendar {
  z-index: 10000;
}
.no-header .vs-popup .vs-popup--content {
  overflow: visible;
}
.min-w-100 {
  min-width: 11rem;
  margin-right: 100px;
}
input {
  padding-left: -80px;
}
</style>
